/**
 * 基础菜单 班级管理
 */
<template>
  <div style="background-color: #F5F5F5">
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学员管理</el-breadcrumb-item>
    </el-breadcrumb>-->

    <!-- 班级详情 -->
    <el-descriptions v-if="typeFlag == 0" class="margin-top" title="班级信息" :column="3" border style="background-color: white; padding: 10px; border-radius: 5px; height: 17vh;">
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-date"></i>
          班级名称
        </template>
        {{ classItem.className }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-s-custom"></i>
          人数限制
        </template>
        {{ classItem.numberLimit == undefined || classItem.numberLimit == '' ? '未限制' : classItem.numberLimit }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user-solid"></i>
          学员数
        </template>
        {{ classItem.studentNum == undefined || classItem.studentNum == '' ? '0' : classItem.studentNum }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-s-check"></i>
          公开报名
        </template>
        {{ classItem.signUpStatus == 1 ? '是' : '否' }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-coin"></i>
          收款金额
        </template>
        {{ classItem.fee }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-collection"></i>
          培训科目
        </template>
        {{ classItem.subjectName }}
      </el-descriptions-item>
    </el-descriptions>


    <div style="background-color: white; padding: 10px; border-radius: 5px; margin-top: 15px; height: 74.8vh;" :style="typeFlag == 1 ? 'height: 100vh' : ''">
      <div class="el-descriptions__title">学员信息</div>

      <!-- 搜索筛选  accordion -->
      <el-collapse ref="coll" v-model="activeCollapseNames">
        <el-collapse-item name="search">
          <template slot="title">
            <!-- 搜索区域折叠行 -->
            <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; width: 100%;" @click.stop="void 0">
              <div style="display: flex; flex-wrap: nowrap; align-items: center;">
                <el-form ref="queryForm" :inline="true" :model="queryParams" class="user-search">
                  <el-form-item label="搜索："></el-form-item>
                  <el-form-item label="" style="width: 180px;">
                    <el-input size="small" style="width: 100%" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.name" placeholder="请输入姓名"></el-input>
                  </el-form-item>
                  <el-form-item label="" style="width: 180px;">
                    <el-input size="small" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.phone" placeholder="请输入手机号码"></el-input>
                  </el-form-item>
                  <el-form-item label="" style="width: 180px;">
                    <el-input size="small" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.idcard" placeholder="请输入身份证号"></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-arrow-down" @click="toggleCollapse">{{ activeCollapseNames.length ? "收起" : "更多" }}</el-button>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                    <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()" v-if="typeFlag == 0">添加学员</el-button>
                    <el-button size="small" type="primary" icon="el-icon-date" @click="handleStudy()" v-if="typeFlag == 0">生成学习卡</el-button>
                  </el-form-item>
                  <el-form-item  v-if="typeFlag == 0">

                    <el-dropdown @command="importData">
                      <el-button size="small" type="primary" icon="el-icon-upload2" >
                        导入
                        <!--            <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="0">花名册</el-dropdown-item>
                        <el-dropdown-item command="1">学员头像</el-dropdown-item>
                        <el-dropdown-item command="2">身份证正面</el-dropdown-item>
                        <el-dropdown-item command="3">身份证反面</el-dropdown-item>
                        <el-dropdown-item command="4">学历证明</el-dropdown-item>
                        <el-dropdown-item command="5">营业执照</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>

                    <el-button
                      size="small"
                      type="primary"
                      icon="el-icon-s-check"
                      @click="approveStu"
                      style="margin: 0 10px; "
                    >
                      审核
                    </el-button>

                    <el-dropdown @command="openClass">
                      <el-button size="small" type="primary" icon="el-icon-refresh" >
                        换班
                        <!--            <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="0">同科目</el-dropdown-item>
                        <el-dropdown-item command="1">跨科目</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>

                    <el-dropdown @command="exportData">
                      <el-button size="small" type="primary" icon="el-icon-download" >
                        导出
                        <!--            <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="0">花名册</el-dropdown-item>
<!--                        <el-dropdown-item command="11">安培通导出</el-dropdown-item>-->
                        <el-dropdown-item command="12">考试系统导出</el-dropdown-item>
                        <el-dropdown-item command="1">学员头像</el-dropdown-item>
                        <el-dropdown-item command="2">身份证正面</el-dropdown-item>
                        <el-dropdown-item command="3">身份证反面</el-dropdown-item>
                        <el-dropdown-item command="4">学历证明</el-dropdown-item>
                        <el-dropdown-item command="5">营业执照</el-dropdown-item>
                        <el-dropdown-item command="6">申请表</el-dropdown-item>
                        <el-dropdown-item command="7">学时证明</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>

                    <el-button
                      size="small"
                      type="primary"
                      icon="el-icon-unlock"
                      @click="resetFace"
                      style="margin-left: 10px;"
                    >
                      重置人脸状态
                    </el-button>

                    <el-button
                      size="small"
                      type="danger"
                      icon="el-icon-delete"
                      @click="cancelStu"
                      style="margin-left: 10px;"
                    >
                      作废
                    </el-button>

                    <!--        <el-button size="small" type="primary" icon="el-icon-download" @click.stop="handleExport($event)">导出</el-button>-->
                    <!--          <el-button size="small" type="info" icon="el-icon-upload2" style="margin-left: 10px;" @click="handleImport">导入</el-button>-->
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </template>

          <!-- 这是折叠的内容区域 -->
          <div
            style="display: flex; flex-wrap: wrap;"
          >
            <el-form
              :model="queryParams"
              ref="queryForm2"
              :inline="true"
              label-width="68px"
            >
              <el-form-item label="" style="width: 180px;">
                <el-select size="small" style="width: 100%" clearable v-model="queryParams.approveStatus" placeholder="请选择审核状态">
                  <el-option v-for="x in statusList" :label="x.label" :value="x.value" :key="x.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" style="width: 180px;">
                <el-select size="small" style="width: 100%" clearable v-model="queryParams.payFeeStatus" placeholder="请选择支付情况">
                  <el-option v-for="x in payList" :label="x.label" :value="x.value" :key="x.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" style="width: 180px;">
                <el-select size="small" style="width: 100%" clearable v-model="queryParams.sftgxx" placeholder="请选择学习进度">
                  <el-option label="已完成" value="1" key="1"></el-option>
                  <el-option label="未完成" value="0" key="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" style="width: 180px;">
                <el-select size="small" style="width: 100%" clearable v-model="queryParams.marSeqId" placeholder="请选择营销渠道">
                  <el-option v-for="x in marList" :label="x.marName" :value="x.marSeqId" :key="x.marSeqId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" style="width: 180px;">
                <el-select size="small" style="width: 100%" clearable v-model="queryParams.learnPlatformSeqId" placeholder="请选择学习平台">
                  <el-option v-for="x in lpList" :label="x.learnPlatformName" :value="x.learnPlatformSeqId" :key="x.learnPlatformSeqId"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!-- 搜索筛选 -->
<!--      <el-form :inline="true" :model="queryParams" class="user-search">
        <el-form-item label="搜索："></el-form-item>
        <el-form-item label="" style="width: 180px;">
          <el-input size="small" style="width: 100%" v-model="queryParams.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="" style="width: 180px;">
          <el-select size="small" style="width: 100%" clearable v-model="queryParams.learnPlatformSeqId" placeholder="请选择学习平台">
            <el-option v-for="x in lpList" :label="x.learnPlatformName" :value="x.learnPlatformSeqId" :key="x.learnPlatformSeqId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" style="width: 180px;">
          <el-select size="small" style="width: 100%" clearable v-model="queryParams.marSeqId" placeholder="请选择营销渠道">
            <el-option v-for="x in marList" :label="x.marName" :value="x.marSeqId" :key="x.marSeqId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" style="width: 180px;">
          <el-select size="small" style="width: 100%" clearable v-model="queryParams.payFeeStatus" placeholder="请选择支付情况">
            <el-option v-for="x in payList" :label="x.label" :value="x.value" :key="x.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" style="width: 180px;">
          <el-input size="small" v-model="queryParams.phone" placeholder="请输入手机号码"></el-input>
        </el-form-item>
&lt;!&ndash;        <el-form-item label="">
          <el-date-picker
            size="small"
            v-model="dateValue"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>&ndash;&gt;
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加学员</el-button>
        </el-form-item>
        <el-form-item style="float: right">

          <el-dropdown @command="importData">
            <el-button size="small" type="primary" icon="el-icon-upload2" >
              导入
              &lt;!&ndash;            <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>&ndash;&gt;
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">花名册</el-dropdown-item>
              <el-dropdown-item command="1">学员头像</el-dropdown-item>
              <el-dropdown-item command="2">身份证正面</el-dropdown-item>
              <el-dropdown-item command="3">身份证反面</el-dropdown-item>
              <el-dropdown-item command="4">学历证明</el-dropdown-item>
              <el-dropdown-item command="5">营业执照</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-button
            size="small"
            type="primary"
            icon="el-icon-s-check"
            @click="approveStu"
            style="margin: 0 10px; "
          >
            审核
          </el-button>

          <el-dropdown @command="openClass">
            <el-button size="small" type="primary" icon="el-icon-refresh" >
              换班
              &lt;!&ndash;            <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>&ndash;&gt;
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">同科目</el-dropdown-item>
              <el-dropdown-item command="1">跨科目</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown @command="exportData">
            <el-button size="small" type="primary" icon="el-icon-download" >
              导出
              &lt;!&ndash;            <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>&ndash;&gt;
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">花名册</el-dropdown-item>
              <el-dropdown-item command="1">学员头像</el-dropdown-item>
              <el-dropdown-item command="2">身份证正面</el-dropdown-item>
              <el-dropdown-item command="3">身份证反面</el-dropdown-item>
              <el-dropdown-item command="4">学历证明</el-dropdown-item>
              <el-dropdown-item command="5">营业执照</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-button
            size="small"
            type="danger"
            icon="el-icon-delete"
            @click="cancelStu"
            style="margin-left: 10px;"
          >
            作废
          </el-button>

          &lt;!&ndash;        <el-button size="small" type="primary" icon="el-icon-download" @click.stop="handleExport($event)">导出</el-button>&ndash;&gt;
&lt;!&ndash;          <el-button size="small" type="info" icon="el-icon-upload2" style="margin-left: 10px;" @click="handleImport">导入</el-button>&ndash;&gt;
        </el-form-item>
      </el-form>-->


      <!--列表-->
      <el-table
        ref="multipleTable"
        size="small"
        :data="listData"
        height="550"
        highlight-current-row
        v-loading="loading"
        border
        element-loading-text="拼命加载中"
        style="width: 100%;"
        @selection-change="handleSelectionChange"
        :row-key="(row) => { return row.id }"
      >
        <el-table-column type="selection" width="55" align="center" :reserve-selection="true" />
        <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60">
        </el-table-column>
        <el-table-column prop="photo" label="头像" width="51">
          <template slot-scope="scope">
            <el-image
              style="width: 20px"
              :src="scope.row.photo"
              v-if="scope.row.photo"
              :preview-src-list="[scope.row.photo]"
              fit="fit">
<!--              <div slot="error" class="el-image__error">
                暂无头像
              </div>
              <div slot="placeholder" class="el-image__error">
                暂无头像
              </div>-->
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="studenId" label="学号" width="100" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="100">
          <template slot-scope="scope">
            <el-link type="primary" v-if="typeFlag == 0" @click="openStudentDetail(scope.row)">
              {{ scope.row.name }}
            </el-link>
            <span v-else>
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="idcardType" label="证件类别" width="100">
        </el-table-column>
        <el-table-column prop="idcard" label="身份证号" width="180">
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" width="150">
        </el-table-column>
        <el-table-column prop="sex" label="性别" width="60">
          <template slot-scope="scope">
            {{ scope.row.sex == 1 ? '男' : scope.row.sex == 0 ? '女' : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="company" label="工作单位" :show-overflow-tooltip="true">
        </el-table-column>
<!--        <el-table-column prop="subjectName" label="培训科目" :show-overflow-tooltip="true">
        </el-table-column>-->
        <el-table-column prop="applyUrl" label="申请表" width="80">
          <template slot-scope="scope">
<!--            <a :href="scope.row.applyUrl" target="_blank">Open PDF</a>-->
            <i v-if="scope.row.applyUrl" class="el-icon-tickets" style="font-size: 40px; cursor: pointer;" @click="lookApplyUrl(scope.row.applyUrl)"></i>
          </template>
        </el-table-column>
        <el-table-column prop="marName" label="营销渠道" :show-overflow-tooltip="true" v-if="typeFlag == 0">
        </el-table-column>
<!--        <el-table-column prop="learnPlatformName" label="学习平台" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="payFeeStatus" label="支付情况" width="120">
          <template slot-scope="scope">
            {{ scope.row.payFeeStatus == '1' ? '已支付' : '未支付' }}
          </template>
        </el-table-column>-->
        <el-table-column prop="createTime" label="报名时间" width="150">
          <template slot-scope="scope">
            <div>{{timestampToTime(scope.row.createTime)}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sftgxx" label="学习进度" width="150">
          <template slot-scope="scope">
            <el-tag type="success" size="small" v-if="scope.row.sftgxx == '1'" class="tags">已完成</el-tag>
            <el-tag type="danger" size="small" v-else class="tags">未完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="wlxyFlag" label="是否发卡" width="150">
          <template slot-scope="scope">
            <el-tag type="success" size="small" v-if="scope.row.wlxyFlag == '1'" class="tags">是</el-tag>
            <el-tag type="danger" size="small" v-else class="tags">否</el-tag>
<!--            {{ scope.row.wlxyFlag == '1' ? '是' : '否' }}-->
          </template>
        </el-table-column>
        <el-table-column prop="approveStatus" label="审核状态" width="120">
          <template slot-scope="scope">
            <el-tag type="success" size="small" v-if="scope.row.approveStatus == 1" class="tags">通过</el-tag>
            <el-tag type="warning" size="small" v-if="scope.row.approveStatus == 2" class="tags">未审核</el-tag>
            <el-tag type="danger" size="small" v-if="scope.row.approveStatus == 3" class="tags">不通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="bzrName" label="班主任"/>
        <el-table-column prop="faceState" label="人脸注册状态" width="120"/>
        <el-table-column prop="faceErrMsg" label="人脸注册错误信息" width="160"/>

        <el-table-column align="center" label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="签到情况"
              placement="top"
            >
              <el-button
                size="mini"
                icon="el-icon-data-analysis"
                @click="handleSignList(scope.$index, scope.row)"
              >
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather" style="position: fixed; bottom: 2vh;"></Pagination>
    </div>

    <!-- 侧拉 展示 学员详情 -->
    <el-drawer
      title="我是标题"
      :visible.sync="stdShow"
      size="70%"
      :with-header="false">
      <student-detail ref="stdDetail" :key="form.id" :item="form" @callBack="callBack" @sxTable="getdata" />
    </el-drawer>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="60%" top="5vh" :close-on-click-modal="false" @click="closeDialog" append-to-body>
      <add-student :key="form.id" :item="form" @sonHandleCallback="sonHandleCallback"></add-student>
    </el-dialog>

    <!-- 学员导入对话框 -->
    <el-dialog :close-on-click-modal="false" :title="upload.title" :visible.sync="upload.open" width="400px" top="6vh"
               append-to-body>
      <el-upload
        ref="upload"
        :limit="1"
        :accept="importFlag == 0 ? '.xlsx, .xls' : '.zip'"
        :action="upload.url"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :on-exceed="handleChang"
        drag
      >
        <!--        :on-exceed	="handleExceed"-->

        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip" v-show="importFlag == 0">
<!--          <el-checkbox v-model="upload.updateSupport"/>
          是否更新已经存在的数据-->
          <el-link type="info" style="font-size:12px;color: red" @click="importTemplate">下载模板</el-link>
        </div>
        <div class="el-upload__tip" style="color:red" slot="tip" v-show="importFlag == 0">提示：仅允许导入“xls”或“xlsx”格式文件！</div>
        <div class="el-upload__tip" style="color:red" slot="tip" v-show="importFlag != 0">提示：仅允许导入“zip”格式文件！</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>


    <!-- 导出页面 -->
    <div v-show="exportShow">
      <div id="menu" class="menu">
        <div class="menu-item" @click="exportData(0)">学历证明</div>
        <div class="menu-item" @click="exportData(1)">学员头像</div>
        <div class="menu-item" @click="exportData(2)">身份证</div>
        <div class="menu-item" @click="exportData(3)">花名册</div>
      </div>
    </div>

    <!-- 换班对话框 -->
    <el-dialog :close-on-click-modal="false" title="换班列表" :visible.sync="classShow" width="60%" top="6vh"
               append-to-body>

      <el-form :inline="true" :model="queryParamsClass" class="user-search">
        <el-form-item label="搜索：">
          <el-input size="small" v-model="queryParamsClass.className" placeholder="输入班级名称"></el-input>
        </el-form-item>
        <el-form-item label="科目" prop="subjectId" v-if="subjectFlag == 1">
          <!-- @change="findClassBySubjectId" -->
          <el-cascader
            size="small"
            style="width: 100%"
            v-model="queryParamsClass.subjectId"
            :options="subjectOptions"
            emitPath="false"
            :props="{ emitPath:false }"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="searchClass">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table
        size="small"
        :data="classList"
        height="250"
        highlight-current-row
        v-loading="loading"
        border
        element-loading-text="拼命加载中"
        style="width: 100%;"
        @selection-change="classIdsChange"
        :row-key="(row) => { return row.id }"
      >
        <el-table-column type="selection" :selectable="selectable" width="55" align="center" :reserve-selection="true" />
        <el-table-column label="序号" align="center" type="index" width="60">
        </el-table-column>
        <el-table-column prop="subjectName" label="培训科目" width="250" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="className" label="班级名称" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="fee" label="收费价格" width="80">
        </el-table-column>
        <el-table-column prop="numberLimit" label="报名人数限制" width="100">
        </el-table-column>
        <el-table-column prop="studentNum" label="学生数" width="80">
        </el-table-column>
        <el-table-column prop="signUpEndTime" label="报名截止时间" width="180">
          <template slot-scope="scope">
            <div>{{scope.row.signUpEndTime ? scope.row.signUpEndTime : '不限制'}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="signUpStatus" label="是否公开报名" width="100">
          <template slot-scope="scope">
            {{ scope.row.signUpStatus == 1 ? '是' : '否' }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submitClass">确 定</el-button>
        <el-button size="small" @click="classShow = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 签到情况 对话框 -->
    <el-dialog :close-on-click-modal="false" title="签到情况" :visible.sync="signShow" width="60%" top="6vh"
               append-to-body>

      <el-table
        size="small"
        :data="signListData"
        height="500"
        highlight-current-row
        v-loading="loading"
        border
        element-loading-text="拼命加载中"
        style="width: 100%;"
      >
        <el-table-column label="序号" align="center" type="index" width="60">
        </el-table-column>
        <el-table-column prop="kcmc" label="课程名称" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="photo" label="签到照片" width="100">
          <template slot-scope="scope">
            <el-image
              style="width: 40px"
              :src="scope.row.photo"
              v-if="scope.row.photo"
              :preview-src-list="[scope.row.photo]"
              fit="fit">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="签到时间" width="180">
          <template slot-scope="scope">
            <div>{{scope.row.createTime ? scope.row.createTime : ''}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="dkfs" label="签到方式" width="100">
          <template slot-scope="scope">
            {{ scope.row.dkfs == 1 ? '手机签到' : scope.row.dkfs == 2 ? '设备签到' : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="signOutPhoto" label="签退照片" width="100">
          <template slot-scope="scope">
            <el-image
              style="width: 40px"
              :src="scope.row.signOutPhoto"
              v-if="scope.row.signOutPhoto"
              :preview-src-list="[scope.row.signOutPhoto]"
              fit="fit">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="signOutTime" label="签退时间" width="180">
          <template slot-scope="scope">
            <div>{{scope.row.signOutTime ? scope.row.signOutTime : ''}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="qtfs" label="签退方式" width="100">
          <template slot-scope="scope">
            {{ scope.row.qtfs == 1 ? '手机签退' : scope.row.qtfs == 2 ? '设备签退' : '' }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      :visible.sync="showProgress"
      :close-on-click-modal="false"
      :show-close="false"
      width="30%"
      top="30vh"
      custom-class="download-dialog"
    >
      <div class="download-content">
        <el-progress
          :percentage="progress"
          :status="progressStatus"
          :stroke-width="18"
          :text-inside="true"
        />
        <div class="progress-message" >
          {{ progressMessage }}
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  queryStudentList,
  saveStudent,
  updateStudent,
  deleteStudentById,
  queryStudentDetail,
  changeClass,    // 换班
  cancelStu,      // 作废

  // 导入 导出接口
  downloadStudentTemplate,
  importStudent,                  // 导入学员花名册
  importStudentImgByType,         // 导入学员图片
  educationCertificateZip,
  idCardImgZip,
  photoZip,
  exportStudent,                  // 导出花名册
  exportStudentImgByType,         // 导出图片
  approve, traingSignUp, updateFaceState

} from '../../../api/student'
import {
  queryStudentByClassId,
  queryClassDetail,
  changeClassList, queryBzrStudentByClassId, queryStudentSignList
} from '../../../api/classInfo'
import { timestampToTime } from '../../../utils/util'
import Pagination from '../../../components/Pagination'
import Template from "../../../components/template";

import AddStudent from "./addStudent"
import StudentDetail from "./studentDetail";
import {selectAreaTree} from "../../../api/subjectTree";
import {getLearnPlatformList, getMarketingChannelList} from "../../../api/userMG";

export default {
  data() {
    return {
      typeFlag: 0,   // 0：班级管理进入   1：班主任班级列表进入
      // 控制学员详情 侧拉框
      stdShow: false,

      classItem: '',    // 班级数据
      subjectId: '',    // 科目ID
      subjectOptions: [],
      subjectFlag: '',    // 同科目/跨科目
      classShow: false,
      ids: [],    // 多选框ids
      dateValue: [],
      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      // rules表单验证
      queryParams: {
        page: 1,
        size: 10,
        name: '',
        learnPlatformSeqId: '',
        marSeqId: '',
        approveStatus: '',
        payFeeStatus: '',
        phone: '',
        startTime: '',
        endTime: '',
        classId: ''
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      // 查询折叠
      activeCollapseNames: [],

      // 用户导入参数
      importFlag: '',
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: "",
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 上传的地址
        url: '/api/student/upload'
      },
      fileFlag: '',

      // 导出 弹框
      exportShow: false,

      queryParamsClass: {},
      classList: [],
      classIds: [],

      // 签到信息
      signListData: [],
      signShow: false,

      // 地区数据
      payList: [
        { value: 0, label: '未支付' },
        { value: 1, label: '已支付' }
      ],
      // 营销渠道
      marList: [],
      // 学习平台
      lpList: [],
      // 审核状态
      statusList: [
        { value: 1, label: '审核通过' },
        { value: 2, label: '未审核' },
        { value: 3, label: '审核不通过' }
      ],

      showProgress: false,
      progress: 0,
      progressMessage: '文件下载中，请稍候...',
      progressStatus: null

    }
  },
  // 注册组件
  components: {
    Template,
    Pagination,
    AddStudent,
    StudentDetail
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    if (this.$route.query.classId) {
      this.queryParams.classId = this.$route.query.classId;
      this.typeFlag = this.$route.query.type;
      this.findClassDetail()
    }
    this.getdata()
    this.selectAreaTree()
    this.findLearnPlatList()
    this.findMarList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    titleFocus() {
      this.collClick = this.$refs.coll.setActiveNames
      this.$refs.coll.setActiveNames = () => {}
    },
    titleBlur() {
      this.$refs.coll.setActiveNames = this.collClick
    },
    // 查询折叠
    toggleCollapse() {
      this.activeCollapseNames = this.activeCollapseNames.length ? [] : ["search"];
    },
    // 查询 学习平台
    findLearnPlatList() {
      getLearnPlatformList(JSON.stringify({query: {status: 1}})).then(res => {
        if (res.code == 200) {
          this.lpList = res.data.list

          this.lpList.unshift({learnPlatformName: '空', learnPlatformSeqId: 0})
        }
      })
    },
    // 查询 营销渠道
    findMarList() {
      getMarketingChannelList(JSON.stringify({query: {status: 1}})).then(res => {
        if (res.code == 200) {
          this.marList = res.data.list
        }
      })
    },

    // 查询 班级详情
    findClassDetail() {
      queryClassDetail({id: this.queryParams.classId}).then(res => {
        if(res.code == 200) {
          this.classItem = res.data;
          document.title = res.data.className;
        }
      })
    },
    // 查询 科目树
    selectAreaTree() {
      selectAreaTree({}).then(res => {
        if (res.code == 200) {
          this.subjectOptions = res.data;
        }
      })
    },
    // 获取学员数据
    getdata() {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      if (this.typeFlag == 1) {
        queryBzrStudentByClassId(this.queryParams).then(res => {
          this.loading = false
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm = res.data.pageparm
            this.pageparm.pageSize = 10;

          }
        })
          .catch(err => {
            this.loading = false
            this.$message.error('加载失败，请稍后再试！')
          })
      } else {
        queryStudentByClassId(this.queryParams).then(res => {
          this.loading = false
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm = res.data.pageparm
            this.pageparm.pageSize = 10;

          }
        })
          .catch(err => {
            this.loading = false
            this.$message.error('加载失败，请稍后再试！')
          })
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.queryParams.page = 1;
      this.getdata()
    },
    // 多选框选中数据
    handleSelectionChange(val) {
      this.ids = JSON.parse(JSON.stringify(val));
    },

    // 打开申请表
    lookApplyUrl(url) {
      window.open(url, '_blank');

      /*const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.style.display = 'none';
      document.body.appendChild(iframe);*/
    },
    // 打开学员详情
    openStudentDetail(item) {
      this.form = item;
      this.stdShow = true;
    },
    callBack() {
      this.title = '修改'
      this.editFormShow = true
    },
    // 显示 签到情况
    handleSignList(index, row) {

      queryStudentSignList({page: 1, size: 9999, classId: row.classId, idcard: row.idcard}).then(res => {
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.signListData = res.data.content;
          this.signShow = true;
        }
      })

    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.form = row;
      } else {
        this.title = '添加'
        this.form = {};
      }
    },
    // 编辑、增加页面保存方法
    submitForm() {
      /*console.log('this.form.areaCode===', this.form.areaCode);
      if (typeof (this.form.areaCode) != 'string' && this.form.areaCode.length > 0) {
        this.form.areaCode = this.form.areaCode[this.form.areaCode.length - 1]
      }*/
      this.form.createTime = new Date(this.form.createTime);
      if (this.form.id != undefined && this.form.id != '') {
        updateStudent(this.form).then(res => {
          this.editFormShow = false
          this.loading = false
          if (res.code == 200) {
            this.search()
            this.$message({
              type: 'success',
              message: '修改成功！'
            })
            this.$refs.stdDetail.queryStudentDetail();
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('修改失败，请稍后再试！')
        })
      } else {
        this.form.classId = this.classItem.id;
        this.form.subjectId = this.classItem.subjectId;
        saveStudent(this.form).then(res => {
          this.editFormShow = false
          this.loading = false
          if (res.code == 200) {
            this.search()
            this.$message({
              type: 'success',
              message: '保存成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('保存失败，请稍后再试！')
        })
      }

    },

    // 生成学习卡
    handleStudy() {
      if (JSON.stringify(this.ids) == '[]') {
        this.$message.error('请选择需要审核的学员！');
        return;
      }

      var idList = []
      for (let i = 0; i < this.ids.length; i++) {
        var x = this.ids[i];
        if (x.wlxyFlag == 1) {
          this.$message.error(x.name + '学员已经生成学习卡，无法重复生成');
          return;
        }
        idList.push(x.id)
      }

      this.$confirm('是否给该批学员生成学习卡?', '提醒', {
        confirmButtonText: '通过',
        cancelButtonText: '不通过',
        type: 'warning'
      })
        .then(() => {
          traingSignUp({studentIds: idList.join(','), classId: this.classItem.id, subjectId: this.classItem.subjectId}).then(res => {
            if (res.code == 200) {
              this.$message.success('生成成功！');
              this.search();
            } else {
              this.$message.info(res.msg);
            }
          }).catch(err => {
            this.$message.error('生成失败！');
          })
        })
        .catch(() => {

        })
    },

    // 批量审核学员
    approveStu() {
      if (JSON.stringify(this.ids) == '[]') {
        this.$message.error('请选择需要审核的学员！');
        return;
      }

      var idList = []
      this.ids.forEach(x => {
        idList.push(x.id)
      })

      this.$confirm('是否通过审核?', '提醒', {
        distinguishCancelAndClose: true,
        confirmButtonText: '通过',
        cancelButtonText: '不通过',
        type: 'warning'
      })
      .then(() => {
        approve({studentIds: idList.join(','), approveStatus: 1}).then(res => {
          if (res.code == 200) {
            this.$message.success('审核成功！');
            this.search();
          } else {
            this.$message.error(res.msg);
          }
        }).catch(err => {
          this.$message.error(err.response.data.msg);
        })
      })
      .catch(action => {
        if (action == 'cancel') {
          approve({studentIds: idList.join(','), approveStatus: 3}).then(res => {
            if (res.code == 200) {
              this.$message.success('审核成功！');
              this.search();
            } else {
              this.$message.error(res.msg);
            }
          }).catch(err => {
            this.$message.error(err.response.data.msg);
          })
        }
      })

    },

    // 重置人脸状态
    resetFace() {
      if (JSON.stringify(this.ids) == '[]') {
        this.$message.error('请选择需要重置的数据！');
        return;
      }

      this.$confirm('确定要重置吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var idList = []
          this.ids.forEach(x => {
            idList.push(x.id)
          })
          updateFaceState({ids: idList.join(','), faceState: 0}).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
              this.search()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.loading = false
              this.$message.error('重置失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    // 批量作废学员
    cancelStu() {
      if (JSON.stringify(this.ids) == '[]') {
        this.$message.error('请选择需要作废的学员！');
        return;
      }

      this.$confirm('确定要作废吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        var idList = []
        this.ids.forEach(x => {
          idList.push(x.id)
        })
        cancelStu({studentIds: idList.join(',')}).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '作废成功!'
            })
            this.search()
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('作废失败，请稍后再试！')
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消作废'
        })
      })
    },
    sonHandleCallback(data) {
      if (data.type == 'back') {
        this.editFormShow = false
      } else if (data.type == 'saveForm') {
        this.form = data.item;
        this.submitForm();
      }
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormShow = false
    },

    /*
    *  导入
    * */
    importData(x) {
      this.importFlag = x;
      if (x == 0) {
        this.upload.title = "花名册导入";
      } else if (x == 1) {
        this.upload.title = "头像导入";
      } else if (x == 2) {
        this.upload.title = "身份证正面导入";
      } else if (x == 3) {
        this.upload.title = "身份证反面导入";
      } else if (x == 4) {
        this.upload.title = "学历证明导入";
      } else if (x == 5) {
        this.upload.title = "营业执照导入";
      }
      this.upload.open = true;
    },
    /** 下载模板操作 */
    importTemplate() {
      downloadStudentTemplate().then(res => {
        const blob = new Blob([res], { type: 'application/octet-stream' });
        // 创建a标签进行下载
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = "学员导入模板.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      /*this.download('/material/materialInfo/importTemplate', {
        ...this.queryParams
      }, `设备台账模版.xls`)*/
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      console.log('file', file);
      // this.upload.open = false;
      this.upload.isUploading = false;
      this.fileFlag = file.raw;
    },
    handleChang(file, fileList) {
      this.$message.error('请删除后在添加文件！')
    },
    // 提交上传文件
    submitFileForm() {
      var formData = new FormData();
      // 上传花名册
      if (this.importFlag == 0) {
        formData.append('file', this.fileFlag);
        formData.append('classId', this.queryParams.classId);
        importStudent(formData).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '导入成功!'
            })
            this.upload.open = false;
            this.$refs.upload.clearFiles();
            this.search()
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      } else {
        // 上传图片
        formData.append('classId', this.queryParams.classId);
        formData.append('file', this.fileFlag);
        if (this.importFlag == 1) {
          formData.append('studentImgType', 'PHOTO');
        } else if (this.importFlag == 2) {
          formData.append('studentImgType', 'ID_CARD_FRONT');
        } else if (this.importFlag == 3) {
          formData.append('studentImgType', 'ID_CARD_BACK');
        } else if (this.importFlag == 4) {
          formData.append('studentImgType', 'EDUCATION_CERTIFICATE');
        } else if (this.importFlag == 5) {
          formData.append('studentImgType', 'BUSINESS_LICENSE');
        }
        importStudentImgByType(formData).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '导入成功!'
            })
            this.upload.open = false;
            this.$refs.upload.clearFiles();
            this.search()
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      }
    },

    // 格式化日期函数
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    /*
    *  导出
    * */
    handleExport(MouseEvent) {
      console.log('MouseEvent', MouseEvent);
      this.exportShow = false;
      this.exportShow = true;
      var menu = document.querySelector('#menu');
      menu.style.left = MouseEvent.clientX + 20 + 'px';
      menu.style.top = MouseEvent.clientY + 5 + 'px';
      document.addEventListener('click', this.foo);

      // this.exportShow = true;
    },
    foo() {
      this.exportShow = false;
      document.removeEventListener('click', this.foo);
    },

    /*
    *  换班
    * */
    // 换班列表 查询
    searchClass() {
      this.findClassBySubjectId()
    },
    // 打开换班窗口
    openClass(x) {
      if (JSON.stringify(this.ids) == '[]') {
        this.$message.error('请选择需要换班的学员！');
        return;
      }
      this.subjectFlag = x;
      this.classShow = true
      if (x == 0) {
        // 同科目  (取勾选数据的classId，直接查班级列表)
        changeClassList({subjectId: this.classItem.subjectId, id: this.classItem.id}).then(res => {
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.classList = res.data
          }
        })
        .catch(err => {
          this.$message.error(err.response.data.msg)
        })

      } else if (x == 1) {
        // 跨科目  (打开弹框，选择科目后，查询班级列表)
        changeClassList().then(res => {
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.classList = res.data
          }
        })
          .catch(err => {
            this.$message.error(err.response.data.msg)
          })
      }
    },
    // 选择班级
    classIdsChange(val){
      this.classIds = JSON.parse(JSON.stringify(val))
      console.log('this.classIds', this.classIds);
    },
    selectable(row) {
      if (this.classIds.length > 0) {
        if (this.classIds[0].id == row.id) {
          return true
        } else {
          return false
        }
      } else {
        return true;
      }
    },

    // 跨科目，选择科目后查询班组列表
    findClassBySubjectId() {
      this.queryParamsClass.id = this.classItem.id
      if (this.subjectFlag == 1) {
        if (this.queryParamsClass.subjectId) {
          changeClassList(this.queryParamsClass).then(res => {
            if (res.code != 200) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.classList = res.data
            }
          })
            .catch(err => {
              this.$message.error('查询班级数据失败，请稍后再试！')
            })
        } else {
          this.$message.error('请选择科目后查询');
        }
      } else {
        this.queryParamsClass.subjectId = this.classItem.subjectId;
        changeClassList(this.queryParamsClass).then(res => {
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.classList = res.data
          }
        })
          .catch(err => {
            this.$message.error('查询班级数据失败，请稍后再试！')
          })
      }

    },

    submitClass() {
      // 处理数据
      var stuIds = []
      var classIds = []
      this.ids.forEach(x => {
        stuIds.push(x.id)
      })
      this.classIds.forEach(x => {
        classIds.push(x.id)
      })
      var params = {
        studentIds: stuIds.join(','),
        classId: classIds.join(',')
      }

      // 提交换班
      changeClass(params).then(res => {
        this.classShow = false;
        if (res.code == 200) {
          this.$message.success('换班成功！');
          this.search()
        } else {
          this.$message.info(res.msg);
        }
      })
      .catch(err => {
        this.$message.error(err.response.data.msg)
      })
    },

    exportData(x) {
      if (x == 0 || x == 11 || x == 12) {
        const currentDate = new Date();
        var title = '';
        var params = {
          /*startTime: this.dateValue.length > 0 ? timestampToTime(this.dateValue[0]).split(' ')[0] : this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)),
          endTime: this.dateValue.length > 0 ? timestampToTime(this.dateValue[1]).split(' ')[0] : this.formatDate(currentDate)*/
          name: this.queryParams.name,
          learnPlatformSeqId: this.queryParams.learnPlatformSeqId,
          marSeqId: this.queryParams.marSeqId,
          approveStatus: this.queryParams.approveStatus,
          payFeeStatus: this.queryParams.payFeeStatus,
          phone: this.queryParams.phone
        }
        params.classId = this.queryParams.classId

        if(x == 0) {
          params.studentExportEnum = 'ROSTER';
          title = "花名册.xlsx";
        } else if (x == 11) {
          params.studentExportEnum = 'AM_PHE_TONE';
          title = "安培通导出.xlsx";
        } else if (x == 12) {
          params.studentExportEnum = 'EXAMINATION_SYSTEM';
          title = "考试系统导出.xls";
        }

        // 花名册
        exportStudent(JSON.stringify(params)).then(res => {
          const blob = new Blob([res], { type: 'application/octet-stream' });
          // 创建a标签进行下载
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = title;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
      } else {
        var title = '';
        var params = {
          name: this.queryParams.name,
          learnPlatformSeqId: this.queryParams.learnPlatformSeqId,
          marSeqId: this.queryParams.marSeqId,
          approveStatus: this.queryParams.approveStatus,
          payFeeStatus: this.queryParams.payFeeStatus,
          phone: this.queryParams.phone
        }
        params.classId = this.queryParams.classId;
        if (x == 1) {
          title = '头像.zip';
          params.exportType = 'PHOTO';
        } else if (x == 2) {
          title = '身份证正面.zip';
          params.exportType = 'ID_CARD_FRONT';
        } else if (x == 3) {
          title = '身份证反面.zip';
          params.exportType = 'ID_CARD_BACK';
        } else if (x == 4) {
          title = '学历证明.zip';
          params.exportType = 'EDUCATION_CERTIFICATE';
        } else if (x == 5) {
          title = '营业执照.zip';
          params.exportType = 'BUSINESS_LICENSE';
        } else if (x == 6) {
          // 初始化状态
          this.showProgress = true;
          this.progress = 0;
          this.progressStatus = null;
          this.progressMessage = '文件下载中，请稍候...';

          // 启动一个假的进度条
          this.timer = setInterval(() => {
            if (this.progress < 95) {
              this.progress += Math.random() * 3 // 模拟进度递增
            }
          }, 200)

          title = '申请表.zip';
          params.exportType = 'APPLY';
        } else if (x == 7) {
          // 初始化状态
          this.showProgress = true;
          this.progress = 0;
          this.progressStatus = null;
          this.progressMessage = '文件下载中，请稍候...';

          // 启动一个假的进度条
          this.timer = setInterval(() => {
            if (this.progress < 95) {
              this.progress += Math.random() * 3 // 模拟进度递增
            }
          }, 200)

          title = '学时证明.zip';
          params.exportType = 'XSZM';
        }

        exportStudentImgByType(JSON.stringify(params)).then(res => {
          const blob = new Blob([res], { type: 'application/octet-stream' });
          // 创建a标签进行下载
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = title;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          if (x == 6) {
            // 下载完成状态
            clearInterval(this.timer)
            this.progress = 100;
            this.progressStatus = 'success';
            this.progressMessage = '下载完成！';

            // 2秒后自动关闭
            setTimeout(() => {
              this.showProgress = false;
            }, 2000);
          } else if (x == 7) {
            // 下载完成状态
            clearInterval(this.timer)
            this.progress = 100;
            this.progressStatus = 'success';
            this.progressMessage = '下载完成！';

            // 2秒后自动关闭
            setTimeout(() => {
              this.showProgress = false;
            }, 2000);
          }
        }).catch(err => {
          console.log(err)
          console.log(err.response)
          this.$message.error(err.response.data.msg);
        })

      }
    }


  }
}
</script>

<style scoped>
.user-search {
  margin-top: 10px;
}
.userRole {
  width: 100%;
}
.btnCss {
  margin-top: 10px;
  margin-left: 0px !important;
}

/* 导出 */
.menu-item {
  display: block;
  line-height: 20px;
  text-align: center;
  margin-top: 2px;
}
.menu-item:hover{
  background-color: #66b1ff;
  color: white;
  cursor:pointer;
}
.menu {
  /*height: 35px;*/
  width: 90px;
  position: absolute;
  border: 1px solid #999;
  border-radius: 10px;
  background-color: #f4f4f4;
  padding: 5px 0px;
}

.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 10px;
}
.el-icon-arrow-down {
  font-size: 12px;
}

/deep/ .el-drawer {
  background-color: #F5F5F5 !important;
  padding: 15px !important;
}

/deep/ .el-collapse {
  margin-top: 10px !important;
  border-top: 0px solid #EBEEF5 !important;
  border-bottom: 0px solid #EBEEF5 !important;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0px;
}

/deep/ .el-collapse-item__arrow{
  display: none;
}

.download-content {
  text-align: center;
  padding: 20px;
}

.progress-message {
  margin-top: 15px;
  font-size: 14px;
  color: #606266;
}

/* 自定义对话框样式 */
.download-dialog {
  border-radius: 8px;
}

.download-dialog .el-dialog__header {
  display: none;
}

.download-dialog .el-dialog__body {
  padding: 0;
}

</style>





// WEBPACK FOOTER //
// src/views/goods/student/student.vue